import {createFeatureI18n} from '@/i18n/createFeatureI18n';
import et from './locales/et.json';
import en from './locales/en.json';
import ru from './locales/ru.json';

export type TsdCancellationKey = keyof typeof et;

export function useTsdCancellationI18n() {
    return createFeatureI18n({et, en, ru});
}
